import React from 'react';
import classNames from 'classnames';

const Audio = ({ toggleAudio, isPlaying }) =>  {

  const audioClass = classNames({
    'audio': true,
    'js-audio': true,
    'audio--playing': isPlaying,
    'audio--muted': !isPlaying
  });

  const audio = isPlaying && !window.mobile ? <audio autoPlay loop><source src="../../audio/sugar-plum.mp3" type="audio/mpeg" /></audio> : <audio muted autoPlay loop><source src="../../audio/sugar-plum.mp3" type="audio/mpeg" /></audio>

  return (
    <a onClick={ () => toggleAudio() } className={audioClass}>
        <svg className="icon " viewBox="0 0 18 18">
            <use className="audio__playing" xlinkHref="#icon-audio-playing"></use>
            <use className="audio__muted" xlinkHref="#icon-audio-muted"></use>
        </svg>
        {audio}
    </a>
  );
}

export default Audio;



/** WEBPACK FOOTER **
 ** ./src/components/Audio/Audio.js
 **/